<template>
  <div class="market-table-wrap">
    <ul class="market-tab">
      <li
        v-for="(coin, index) in getMarketGroup"
        :key="index"
        :class="{ active: coin === currentCoin }"
        @click="currentCoin = coin"
      >
        {{ coin }}
      </li>
    </ul>
    <div class="market-content-wrap ml-0 ml-lg-5 mb-4">
      <ul class="market-table table-head">
        <li>
          <div v-for="(item, index) in marketListTitle" :key="index" class="light small" :class="item.class">
            <span>{{ item.title }}</span>
            <!-- <span>
              <img :src="require('@/assets/images/home/filtter_arrow_down_a.png')" alt="" />
              <img :src="require('@/assets/images/home/filtter_arrow_down_a.png')" alt="" />
            </span>-->
          </div>
        </li>
      </ul>
      <ul class="market-table">
        <li
          v-for="(market, index) in getSortedMarketListByCurrency[currentCoin]"
          v-if="market.status == 1 && (recordToShow === -1 || index < recordToShow)"
          :key="index"
        >
          <div>
            <router-link class="dark" :to="`/exchange?pair=${market.symbol}`">{{ market.pair }}</router-link>
          </div>
          <div class="lastPrice">
            <span>{{ '0' == market.close || 0 == market.close ? '0.00' : !market.close ? '-' : market.close }}</span>
            <span style="color:#9ca9b5; font-size:13px">{{ !market.usd ? '' : `≈ ${market.usd}` }}</span>
          </div>
          <div v-if="market.change" class="d-flex justify-end">
            <span class="light" v-if="Number(market.change) === 0">{{ market.change }}%</span>
            <span v-if="Number(market.change) > 0" class="color-success">+{{ market.change }}%</span>
            <span v-if="Number(market.change) < 0" class="color-error">{{ market.change }}%</span>
          </div>

          <div class="light d-flex justify-end" v-if="!market.change">-</div>
          <div class="light d-flex justify-end">{{ !market.high ? '-' : market.high }}</div>
          <div class="light d-flex justify-end">{{ !market.low ? '-' : market.low }}</div>
          <div class="light d-flex justify-end">{{ !market.volume ? '-' : market.volume }}</div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
// import { marketApi } from '@/api/marketApi';
import { mapGetters, mapActions } from 'vuex';
import { getterTypes } from '@/store/getter-types';

export default {
  name: 'AllMarketTable',
  props: {
    recordToShow: {
      type: Number,
      default: -1
    }
  },
  components: {},
  data() {
    return {
      currentCoin: 'USDT',
      marketListTitle: [
        {title: this.$t('market.list.table.header.pair'), class:'d-flex'},
        {title: this.$t('market.list.table.header.lastPrice'), class:'d-flex'},
        {title: this.$t('market.list.table.header.24HChange'), class:'d-flex justify-end'},
        {title: this.$t('market.list.table.header.24HHigh'), class:'flex justify-end'},
        {title: this.$t('market.list.table.header.24HLow'), class:'flex justify-end'},
        {title: this.$t('market.list.table.header.24HVol'), class:'flex justify-end'},
      ],
      marketListGroup: [],
      marketList: [
        // { pair: "BTCUSDT", volume: "50", close: "2.1", change: "0.000", low: "2.1", high: "100.11" },
      ],
      // coin = base unit
      // marketCoin = quote unit
      sortedMarketList: {}
    };
  },
  computed: {
    ...mapGetters(['Getter_Current_Currency', 'getMarketGroup', 'getSortedMarketListByCurrency', getterTypes.Getter_Socket_State])
  },
  watch: {
    Getter_Current_Currency: function(val) {
      if (val) {
        this.alterMarketListByCurrency_action();
      }
    },
    Getter_Socket_State(value) {
      if (value) {
        this.subscribeMarketList();
      }
    }
  },
  mounted() {
    if (this.isEmpty(this.getMarketGroup)) {
      this.getMarketGroup_action();
    }
    if (this.Getter_Socket_State) {
      this.subscribeMarketList();
    }
    this.getMarketList_action();
  },
  beforeDestroy() {
    this.unsubscribeMarketList();
  },
  methods: {
    ...mapActions([
      'getMarketGroup_action',
      'getMarketList_action',
      'alterMarketListByCurrency_action',
      'updateMarketList_action',
      'updateMarketHotList_action'
    ]),
    subscribeMarketList() {
      this.$socket.subscribe('marketList', value => {
        if (value) {
          this.updateMarketList_action(value.data);
          let param = {
            value: value.data,
            fromSocket: true
          };
          this.updateMarketHotList_action(param);
        }
      });
    },
    unsubscribeMarketList() {
      this.$socket.unsubscribe('marketList');
    }
    // getMarketGroup() {
    // marketApi.getMarketGroup().then(response => {
    //   this.marketListGroup = response.data;
    // }).catch(error => {
    // });
    // },
    // alterMarketListByCurrency(flag = null) { // flag: 1 = first load
    //   if (!this.isUndefinedOrNullOrEmpty(this.Getter_Current_Currency)) {
    //     if (flag === 1) {
    //       if (this.Getter_Current_Currency.abbreviation !== 'USD') {
    //         for (let item of this.marketList) {
    //           item.close = item.close * this.Getter_Current_Currency.rate;
    //           item.high = item.high * this.Getter_Current_Currency.rate;
    //           item.open = item.open * this.Getter_Current_Currency.rate;
    //           item.low = item.low * this.Getter_Current_Currency.rate;
    //           item.amount = item.amount * this.Getter_Current_Currency.rate;
    //         }
    //       }
    //     } else {
    //       for (let item of this.marketList) {
    //         item.close = item.close * this.Getter_Current_Currency.rate;
    //         item.high = item.high * this.Getter_Current_Currency.rate;
    //         item.open = item.open * this.Getter_Current_Currency.rate;
    //         item.low = item.low * this.Getter_Current_Currency.rate;
    //         item.amount = item.amount * this.Getter_Current_Currency.rate;
    //       }
    //     }
    //   }
    // },
    // processMarketList() {
    //   let tempMarketList = {};
    //   for (let item of this.marketList) {
    //     if (!tempMarketList[item.marketCoin]) {
    //       tempMarketList[item.marketCoin] = [];
    //     }
    //     item.pair = item.coin + '/' + item.marketCoin;
    //     tempMarketList[item.marketCoin].push(item);
    //   }
    //   this.sortedMarketList = tempMarketList;
    // },
  }
};
</script>

<style lang="stylus" scoped>
.market-table-wrap {
  background-color: #fff;
  border-radius: 4px;
  overflow: hidden;
  // max-width: 1500px;
  // min-width: 800px;

  ul {
    padding-left: 0px;
  }

  .market-tab {
    display: flex;
    background-color: rgba(26, 31, 51, 0.04);

    li {
      padding: 0 20px;
      font-size: 14px;
      font-weight: bold;
      line-height: 52px;
      color: #889dbf;
      background-color: transparent;
      cursor: pointer;
      user-select: none;

      &.active {
        background-color: #fff;
        color: rgba(30, 73, 172, 1);
      }
    }
  }

  .market-content-wrap {
    overflow-x: auto;
    // white-space: nowrap;
    // max-width: 1500px;
    // min-width: 800px;

    .market-table {
      li {
        display: flex;
        // line-height: 40px;
        // justify-content: space-between;
        min-height: 30px;
        padding-bottom: 10px;
        padding-top: 10px;

        div {
          padding: 0 20px;
          width: 100%;
          // flex: 1 1 0px;
          // max-width: 150px;
          display: flex;
          font-size: 14px;
          word-break: break-all;
          align-items: start;
          box-sizing: border-box;

          &:first-child {
            // width: 100px;
            min-width: 170px;
            max-width: 170px;
          }

          &:nth-child(2) {
            /* flex: 2 2 0; */
            min-width: 180px;
            max-width: 190px;
          }

          &:nth-child(n + 3) {
            min-width: 150px;
            max-width: 190px;
          }
        }

        .lastPrice {
          // white-space: nowrap;
          display: block;
        }

        .lastPrice > span {
          display: inline-block;
          font-size: 13px;
        }

        .lastPrice > span:first-child {
          margin-right: 5px;
        }
      }

      span {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }

      .small {
        font-size: 12px;
      }

      .dark {
        color: #283f75;
      }

      .light {
        color: #889dbf;
      }

      .green {
        color: #1dce8a;
      }

      .red {
        color: #ff5858;
      }
    }

    .table-head {
      span {
        &:first-child {
          line-height: 40px;
        }

        &:last-child {
          // padding: 0 6px;
          cursor: pointer;
        }

        &:last-child img {
          margin: 1px 0;
        }

        &:last-child img:first-child {
          transform: rotate(180deg);
        }
      }
    }
  }
}
</style>
